<template>
  <el-dialog
    :title="$t('editBasePrivilege.editPrivilege')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog">
    <el-form :model="editBasePrivilegeInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('editBasePrivilege.privilegeName')" prop="name">
        <el-input
          v-model="editBasePrivilegeInfo.name"
          :placeholder="$t('editBasePrivilege.inputPrivilegeName')"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editBasePrivilege.resourcePath')" prop="resource">
        <el-input
          v-model="editBasePrivilegeInfo.resource"
          :placeholder="$t('editBasePrivilege.inputResourcePath')"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editBasePrivilege.merchantType')" prop="domain">
        <el-select
          v-model="editBasePrivilegeInfo.domain"
          :placeholder="$t('editBasePrivilege.selectMerchantType')"
          style="width:100%">
          <el-option
            v-for="item in merchantTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editBasePrivilege.description')">
        <el-input
          type="textarea"
          v-model="editBasePrivilegeInfo.description"
          :placeholder="$t('editBasePrivilege.inputDescription')"
          :rows="3">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editBasePrivilege">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateBasePrivilege } from '@/api/dev/basePrivilegeApi'

export default {
  name: 'EditBasePrivilege',
  data() {
    return {
      dialogVisible: false,
      editBasePrivilegeInfo: {
        pId: '',
        name: '',
        resource: '',
        domain: '',
        description: '',
        mId: ''
      },
      merchantTypes: [
        { value: '800900000001', label: this.$t('editBasePrivilege.operationTeam') },
        { value: '800900000005', label: this.$t('editBasePrivilege.merchant') },
        { value: '800900000000', label: this.$t('editBasePrivilege.devTeam') }
      ],
      rules: {
        name: [
          { required: true, message: this.$t('editBasePrivilege.privilegeNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: this.$t('editBasePrivilege.privilegeNameLength'), trigger: 'blur' }
        ],
        resource: [
          { required: true, message: this.$t('editBasePrivilege.resourcePathRequired'), trigger: 'blur' },
          { min: 2, max: 200, message: this.$t('editBasePrivilege.resourcePathLength'), trigger: 'blur' }
        ],
        domain: [
          { required: true, message: this.$t('editBasePrivilege.merchantTypeRequired'), trigger: 'change' }
        ],
        pId: [
          { required: true, message: this.$t('editBasePrivilege.privilegeIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.editBasePrivilegeInfo = Object.assign({}, params)
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.editBasePrivilegeInfo = {
        pId: '',
        name: '',
        resource: '',
        domain: '',
        description: '',
        mId: ''
      }
    },
    editBasePrivilege() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        
        updateBasePrivilege(this.editBasePrivilegeInfo)
          .then(() => {
            this.$message.success(this.$t('editBasePrivilege.saveSuccess'))
            this.closeDialog()
            this.$emit('success')
          })
          .catch(error => {
            console.error('更新失败:', error)
            this.$message.error(this.$t('editBasePrivilege.saveFailed'))
          })
      })
    }
  }
}
</script>